const INITIAL_VALUE = {
    usuarios: [],
    usuario: {},
    usuarioCadastroFuncionario: {},
    listaPerfil: [],
    listaPerfilAdmin: [],
    loading: false,
}

export default function Usuario(state = INITIAL_VALUE, action) {
    switch (action.type) {
        case 'USUARIO_LOADING' :
            return { ...state, loading: action.payload };
        case 'USUARIOS_FETCHED':
            return { ...state, usuarios: action.payload }
        case 'USUARIO_FETCHED':
            return { ...state, usuario: action.payload }
        case 'USUARIO_FUNCIONARIO_FETCHED':
            return { ...state, usuarioCadastroFuncionario: action.payload }
        case 'LISTA_PERFIL_FETCHED':
            return { ...state, listaPerfil: action.payload }
        case 'LISTA_PERFIL_ADMIN_FETCHED':
            return { ...state, listaPerfilAdmin: action.payload }
        case 'PERFIL_NEGOCIO_USUARIO_FETCHED':
            return { ...state, perfilNegocioUsuario: action.payload }
        default:
            return state
    }
}